import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TdoSearchComponent} from './common/tdo-search/tdo-search.component';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatListModule} from '@angular/material/list';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TdoMultiselectDropdownModule} from './common/tdo-multiselect-dropdown/tdo-multiselect-dropdown.module';
import {TdoTableComponent} from './common/tdo-table/tdo-table.component';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TdoColorPickerComponent} from './common/tdo-color-picker/tdo-color-picker.component';
import {ColorChromeModule} from 'ngx-color/chrome';
import {TdoDropdownComponent} from './common/tdo-dropdown/tdo-dropdown.component';
import {MatSelectModule} from '@angular/material/select';
import {TdoInputComponent} from './common/tdo-input/tdo-input.component';
import {TdoImagePickerComponent} from './common/tdo-image-picker/tdo-image-picker.component';
import {TdoColorSchemeDropdownComponent} from './common/tdo-color-scheme-dropdown/tdo-color-scheme-dropdown.component';
import {TdoColorSchemePickerComponent} from './common/tdo-color-scheme-picker/tdo-color-scheme-picker.component';
import {DirectivesModule} from '../directives/directives.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import {TdoConfigurationActionBarComponent} from './common/tdo-configuration-action-bar/tdo-configuration-action-bar.component';
import {MatCardModule} from '@angular/material/card';
import {TdoProgressSpinnerComponent} from './common/tdo-progress-spinner/tdo-progress-spinner.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TdoAccordionComponent} from './common/tdo-accordion/tdo-accordion.component';
import {TdoAccordionItemComponent} from './common/tdo-accordion/tdo-accordion-item/tdo-accordion-item.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {TdoAccordionItemHeaderComponent} from './common/tdo-accordion/tdo-accordion-item/tdo-accordion-item-header/tdo-accordion-item-header.component';
import {TdoAccordionItemContentComponent} from './common/tdo-accordion/tdo-accordion-item/tdo-accordion-item-content/tdo-accordion-item-content.component';
import {TdoTableColumnComponent} from './common/tdo-table-v2/tdo-table-column/tdo-table-column.component';
import {TdoTableV2Component} from './common/tdo-table-v2/tdo-table-v2.component';
import {TdoTreeComponent} from './common/tdo-tree/tdo-tree.component';
import {MatTreeModule} from '@angular/material/tree';
import {TdoTreeItemComponent} from './common/tdo-tree/tdo-tree-item/tdo-tree-item.component';
import {TdoImageGridComponent} from './common/tdo-image-grid/tdo-image-grid.component';
import {TdoBasicDropdownComponent} from './common/tdo-basic-dropdown/tdo-basic-dropdown.component';
//import {FlexLayoutModule} from '@angular/flex-layout';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {TdoMiniCalendarComponent} from './common/tdo-mini-calendar/tdo-mini-calendar.component';
import {TdoMdiManagerComponent} from './tdo-mdi-manager/tdo-mdi-manager.component';
import {TdoMdiItemComponent} from './tdo-mdi-manager/tdo-mdi-item/tdo-mdi-item.component';
import {TdoDragNResizeComponent} from './tdo-mdi-manager/tdo-drag-n-resize/tdo-drag-n-resize.component';
import {NgxDragResizeModule} from '@tdo-inc/ngx-drag-resize/dist/ngx-drag-resize';
import {TdoMultiDropdownComponent} from './tdo-multi-dropdown/tdo-multi-dropdown.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TdoSimpleNoteComponent} from './common/tdo-simple-note/tdo-simple-note.component';
import {TdoDropdownV2Component} from './common/tdo-dropdown-v2/tdo-dropdown-v2.component';
import { TdoEnumSelectComponent } from './common/tdo-enum-select/tdo-enum-select.component';
import { TdoDocumentViewerComponent } from './common/tdo-document-viewer/tdo-document-viewer.component';
import { TdoUserIconSelectorComponent } from './tdo-user-icon-selector/tdo-user-icon-selector.component';
import { TdoInputV2Component } from './common/tdo-input-v2/tdo-input-v2.component';
import { TdoDateInputComponent } from './common/tdo-date-input/tdo-date-input.component';
import {TextMaskModule} from 'angular2-text-mask';
import { TdoTimeInputComponent } from './common/tdo-time-input/tdo-time-input.component';
import { TdoPatientSearchComponent } from './tdo-patient-search/tdo-patient-search.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {TdoListComponent} from './common/tdo-list/tdo-list.component';
import { FormatPhonePipe } from '../pipes/format-phone.pipe';
import { PipeModule } from '../pipes/pipe.module';
import {MatGridListModule} from '@angular/material/grid-list';
import { TdoIconPickerComponent } from './common/tdo-icon-picker/tdo-icon-picker.component';
import { TdoTaskListComponent } from  '../main-interface/controls/tdo-task-list/tdo-task-list.component';
import { ItemFilterPipe } from '../pipes/item-filter.pipe';
import {DevExtremeModule} from "devextreme-angular";
import { TdoSelectDialogComponent } from './common/tdo-select-dialog/tdo-select-dialog/tdo-select-dialog.component';


@NgModule({
  declarations: [
    TdoSearchComponent,
    TdoTableComponent,
    TdoTableV2Component,
    TdoColorPickerComponent,
    TdoDropdownComponent,
    TdoInputComponent,
    TdoImagePickerComponent,
    TdoColorSchemeDropdownComponent,
    TdoColorSchemePickerComponent,
    TdoConfigurationActionBarComponent,
    TdoProgressSpinnerComponent,
    TdoAccordionComponent,
    TdoAccordionItemComponent,
    TdoAccordionItemHeaderComponent,
    TdoAccordionItemContentComponent,
    TdoTableColumnComponent,
    TdoTreeComponent,
    TdoTreeItemComponent,
    TdoImageGridComponent,
    TdoBasicDropdownComponent,
    TdoMiniCalendarComponent,
    TdoMdiManagerComponent,
    TdoMdiItemComponent,
    TdoDragNResizeComponent,
    TdoMultiDropdownComponent,
    TdoSimpleNoteComponent,
    TdoDropdownV2Component,
    TdoEnumSelectComponent,
    TdoDocumentViewerComponent,
    TdoUserIconSelectorComponent,
    TdoInputV2Component,
    TdoDateInputComponent,
    TdoTimeInputComponent,
    TdoPatientSearchComponent,
    TdoListComponent,
    TdoIconPickerComponent,
    TdoTaskListComponent,
    TdoSelectDialogComponent,
  ],
    imports: [
        MatInputModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        FormsModule,
        TdoMultiselectDropdownModule,
        ColorChromeModule,
        MatSelectModule,
        DirectivesModule,
        MatPaginatorModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatTreeModule,
        MatMenuModule,
        MatListModule,
        //FlexLayoutModule,
        DragDropModule,
        NgxDragResizeModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        TextMaskModule,
        PipeModule,
        CommonModule,
        MatGridListModule,
        DevExtremeModule

    ],
    exports: [
        TdoSearchComponent,
        TdoTableComponent,
        TdoTableV2Component,
        TdoColorPickerComponent,
        TdoDropdownComponent,
        TdoInputComponent,
        TdoImagePickerComponent,
        TdoColorSchemeDropdownComponent,
        TdoColorSchemePickerComponent,
        TdoConfigurationActionBarComponent,
        TdoProgressSpinnerComponent,
        TdoAccordionComponent,
        TdoAccordionItemComponent,
        TdoAccordionItemHeaderComponent,
        TdoAccordionItemContentComponent,
        TdoTableColumnComponent,
        TdoTreeComponent,
        TdoImageGridComponent,
        TdoBasicDropdownComponent,
        TdoMiniCalendarComponent,
        TdoMdiManagerComponent,
        TdoMdiItemComponent,
        TdoDragNResizeComponent,
        TdoMultiDropdownComponent,
        TdoSimpleNoteComponent,
        TdoDropdownV2Component,
        TdoEnumSelectComponent,
        TdoDocumentViewerComponent,
        TdoUserIconSelectorComponent,
      TdoInputV2Component,
      TdoDateInputComponent,
      TdoTimeInputComponent,
      TdoPatientSearchComponent,
      TdoListComponent,
      TdoTaskListComponent
    ],
    providers: [
      FormatPhonePipe,
      ItemFilterPipe
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class TdoControlsModule {
}
